module.exports = __webpack_public_path__ + "static/roboto-bold-95e3f9bbfb533cb3d6d64037310d1e1e.woff";